import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import styles from "./dropdown.module.scss";

const SingleSelect = ({ label, value, onChange, options, name }) => {
  return (
    <FormControl fullWidth className={styles.dropdownControl}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={onChange} name={name}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SingleSelect;
